module.exports = __webpack_public_path__ + "static/media/luckyThree-0.71883029.png";